import { useHistory, useLocation } from "react-router-dom";
import { useFormikContext } from "formik";
import { useMutation, useQueryClient } from "react-query";
import useFirebase from "../components/Firebase/useFirebase";
import { set } from "lodash";

export const useGetUserInfo = () => {
    const firebase = useFirebase();
    const history = useHistory();
    const formik= useFormikContext();
    const location = useLocation();
    console.log("Location::",location.pathname.split('/'))
    const locationSplit= location.pathname.split('/')
    let request= {}
    if(locationSplit.length >1){
        set(request,locationSplit[1],locationSplit[2])
    }
    console.log("request::",request)
    return useMutation(
      async (values) => {
            const result= await firebase.doGetSalesforceUser(request);
            console.log("Result::",result)
            return result;
      },
      {
        onSuccess: async (resultInitial) => {
          console.log("Success:",resultInitial)
          formik.setValues({...formik.values,...resultInitial,...request});
        },
        onError: (err) => {
          console.error(err);
        },
      }
    );
  };

  export const useUpdateOptions = () => {
    const firebase = useFirebase();
    const history = useHistory();
    const formik= useFormikContext();
    const location = useLocation();

    return useMutation(
      async (values) => {
            const result= await firebase.doUpdateMarketingOptions(formik.values);
            console.log("Updating::",result)
            return result;
      },
      {
        onSuccess: async (resultInitial) => {
          console.log("Updated:",resultInitial)
          history.push({ pathname: '/success'});
        },
        onError: (err) => {
          console.error(err);
        },
      }
    );
  };